import { CircularProgress } from '@mui/material'
import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

interface LoadingSpinnerProps {
  label?: string
  size?: number
}

// Brand-colored spinner used for the loyalty tab loading states.
// Centralized so all three tabs (Overview, Members, Rules) stay in sync if
// the spinner styling needs to change.
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label,
  size = 32,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      padding: '40px 0',
    }}
  >
    <CircularProgress
      size={size}
      thickness={4}
      sx={{ color: p.brand.primary }}
    />
    {label && <div style={{ fontSize: 13, color: p.gray[500] }}>{label}</div>}
  </div>
)
